import React, { useEffect } from "react";

import {
  TextField,
  TextFieldProps,
  Typography,
  Stack,
  Box,
} from "@mui/material";
import { Field, FieldProps } from "formik";
import InfoMsg from "../InfoMsg";

type Props = TextFieldProps & {
  info?: string;
  changeHandler?: () => void; // Added for customer poc section
  value?: string; // Added for customer poc section
};

const FormikInput = (props: Props) => {
  const { name, info, required, label, value, changeHandler, ...otherProps } =
    props;

  // To update the redux state for customer POC section
  useEffect(() => {
    if (changeHandler) {
      changeHandler();
    }
  }, [value]);

  return (
    <Field name={name}>
      {({ field, form, meta }: FieldProps) => {
        const { setFieldValue } = form;
        const error = otherProps.error
          ? otherProps.error
          : meta.touched && meta.error
          ? true
          : false;
        const helperText = otherProps.helperText ? (
          otherProps.helperText
        ) : error && name ? (
          <>{meta.error}</>
        ) : null;
        const handleChange:
          | React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>
          | undefined = (e) => {
          if (name) {
            setFieldValue(name, e.target.value);
          }
        };
        return (
          <Box>
            <Stack direction="row">
              <Typography
                component="span"
                variant="subtitle2"
                className={`${required ? "field-required" : ""}`}
              >
                {label}
              </Typography>
              {info && <InfoMsg info={info} />}
            </Stack>
            <TextField
              id={name}
              fullWidth
              variant="outlined"
              {...otherProps}
              {...field}
              error={error}
              helperText={helperText}
              onChange={handleChange}
            />
          </Box>
        );
      }}
    </Field>
  );
};

export default FormikInput;
